export const b2bVoluntaryPaymentCreateTranslations = {
  title: "Création d'opération",
  button: 'Créer',
  steps: {
    1: 'Informations générales',
    2: 'Montants',
    3: 'Paiement',
    4: 'Confirmation',
  },
  actions: {
    success: 'Paiement volontaire créé',
    failure: 'Échec de la création du paiement volontaire : %{error}',
    restricted: 'Un paiement volontaire ne peut pas être créé sur un contrat résilié.',
    add_allocation: 'Ajouter une allocation',
  },
  choices: {
    type: {
      voluntary_payment: 'Paiement volontaire',
      arbitrage: 'Arbitrage',
    },
    payment_method: {
      regular_bank: 'Virement bancaire',
      sepa_direct_debit: 'Prélèvement SEPA',
      sepa_direct_debit_with_account: 'Prélèvement SEPA •• %{last_digits}',
    },
    deductibility: {
      deductible: 'Déductible',
      non_deductible: 'Non déductible',
    },
  },
  sections: {
    affiliate_information: "Informations de l'affilié",
    type: "Type d'opération",
    payment: 'Moyen de paiement',
    summary_confirmation: 'Récapitulatif et confirmation',
    confirmations: 'Confirmations',
    confirm_accuracy: "Je confirme l'exactitude des données",
  },
  fields: {
    b2b_company_id: "ID de l'entreprise",
    b2b_employee_id_search: 'Recherche avec ID / Nom / NIR / Matricule',
    saving_plan_id: 'Plan',
    amount: 'Montant',
    instrument: 'Instrument',
    deductibility: 'Déductibilité',
    total_invested: 'Montant total',
    total_matching_contribution: 'Abondement total',
    total_entry_fee_employee: "Frais d'entrée (salarié)",
    total_entry_fee_company: "Frais d'entrée (entreprise)",
  },
  messages: {
    no_employees_found: 'Employé non trouvé',
    no_plans_terminated_contract:
      "Les plans d'un contrat résilié ne sont pas disponibles pour un paiement volontaire.",
    type_subtitle:
      "Sélectionnez le type de transaction que vous souhaitez créer, qu'il s'agisse d'un paiement ponctuel ou récurrent.",
    bank_info_line_1: 'Informations bancaires à fournir au salarié :',
    bank_info_beneficiary: 'Nom du bénéficiaire : %{name}',
    bank_info_iban: 'IBAN : %{iban}',
    bank_info_bic: 'BIC/SWIFT : %{bic}',
    bank_info_reference: 'Référence de paiement : %{reference}',
  },
};
